module.exports = __webpack_public_path__ + "static/media/IMG_6421-min.83fa1cf5.jpg";